import { CustomFeature, TutorialBlock } from '@/types/exchanges/page';

export const GoldFarsiLabels: Record<string, string> = {
    activityType: 'نوع فعالیت',
    physicalDelivery: 'امکان تحویل فیزیکی',
    fees: 'کارمزد خرید/فروش',
    minAmount: 'حداقل مبلغ خرید',
    year: 'سال تاسیس',
    customFeature: 'ویژگی سفارشی',
    installmentPurchase: 'خرید اقساطی',
    associationLicense: 'مجوز اتحادیه فروشنگان طلا',
};
export interface GeneralInfo {
    activityType: string;
    physicalDelivery: boolean;
    installmentPurchase: boolean;
    associationLicense: boolean;
    minAmount: number;
    minAmountType: string;
    fees: string;
    rank: string;
    year: string;
    customFeature: CustomFeature[];
    brokerRating: {
        finalRating?: string;
        realRating?: string;
        admin?: string;
    };
}
export interface GoldFields {
    generalInfo: GeneralInfo;
    tutorialBlock: TutorialBlock[];
    tutorialTitle?: string;
}
